// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import {
  InventoryFilters,
  allInventoryResponseSchema,
} from '@/inventory/api/types';
import queryString from 'query-string';

/**
 * Gets all inventory (bulk items + assets + assemblies) with optional filters
 *
 * Endpoint: GET /v1/inventory/all
 *
 * @param filters - Optional filters to apply to the inventory query
 * @returns Promise resolving to all inventory response
 */
export async function getAllInventory(filters?: InventoryFilters) {
  const url = '/v1/inventory/all';
  const response = await api.get(url, {
    paramsSerializer: (parameters) => queryString.stringify(parameters),
    params: filters,
  });
  return parseResponse(allInventoryResponseSchema, response.data, {
    schemaName: 'AllInventory',
    endpoint: url,
  });
}
